import { Injectable } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';

import type { User } from '@recruitee/account-types';

interface InterviewResultForm {
  valid?: boolean;
  rating?: string;
  lastSave?: string;
  touched?: boolean;
  edit?: boolean;
}

interface InterviewResultTemplate {
  admins: User[];
  label: string;
  value: number | undefined;
}

@Injectable({ providedIn: 'root' })
export class InterviewResultsController {
  public formChanged$ = new BehaviorSubject<InterviewResultForm>({});
  public addTemplate$ = new Subject<InterviewResultTemplate>();

  public pushChange(
    form: {
      valid: boolean;
      rating: string;
    } & InterviewResultForm,
  ): void {
    this.formChanged$.next(form);
  }

  public addTemplate(template: InterviewResultTemplate): void {
    this.addTemplate$.next(template);
  }
}
